import { createTheme } from '@mui/material/styles';
import Theme from './theme';

// Function to create a custom palette
export default function Palette(mode, presetColor) {
  const customPalettes = {
    grey: [
      '#ffffff', '#fafafa', '#f5f5f5', '#f0f0f0', '#d9d9d9',
      '#bfbfbf', '#8c8c8c', '#595959', '#262626', '#141414',
      '#000000'
    ],
    blue: ['#e3f2fd', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#487FFF', '#1976d2', '#1565c0', '#0d47a1'],
    red: ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#ef5350', '#f44336', '#e53935', '#d32f2f', '#c62828'],
    gold: ['#fff8e1', '#ffecb3', '#ffe082', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000', '#ff8f00'],
    cyan: ['#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f'],
    green: ['#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32']
  };

  // Include grey in the custom palettes
  customPalettes.grey = [
    ...customPalettes.grey,
    '#fafafa', '#bfbfbf', '#434343', '#1f1f1f', '#fafafb', '#e6ebf1'
  ];

  // Create the palette using Theme function
  const paletteColor = Theme(customPalettes);

  // Return MUI theme
  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      text: {
        primary: paletteColor.grey[700] || '#000',
        secondary: paletteColor.grey[500] || '#666',
        disabled: paletteColor.grey[400] || '#999'
      },
      action: {
        disabled: paletteColor.grey[300] || '#ccc'
      },
      divider: paletteColor.grey[200] || '#e0e0e0',
      background: {
        paper: paletteColor.grey[0] || '#fff',
        default: "#F5F6FA"
      }
    }
  });
}
